import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

import css from './styles.module.scss';

const saleMarkVariant = cva('', {
  variants: {
    wrapper: {
      default: css.defaultSaleMark,
    },
    textStyle: {
      default: css.defaultSaleText,
    },
  },
});

interface SaleMarkProps
  extends VariantProps<typeof saleMarkVariant>,
    HTMLAttributes<HTMLSpanElement> {
  text: string;
}

const SaleMark = forwardRef<HTMLSpanElement, SaleMarkProps>(
  ({ text, wrapper = 'default', textStyle = 'default', ...props }, ref) => {
    return (
      <span
        ref={ref}
        {...props}
        className={cn(saleMarkVariant({ wrapper }), props.className)}
      >
        <span className={saleMarkVariant({ textStyle })}>{text}</span>
      </span>
    );
  },
);

export { SaleMark };
